import { useEffect, useState } from 'react';

export function usePagination(items, pageSize, resetKey) {
  const [page, setPage] = useState(1);
  const list = items || [];
  const total = list.length;
  const totalPages = Math.max(1, Math.ceil(total / pageSize) || 1);
  const safePage = Math.min(page, totalPages);

  useEffect(() => {
    setPage(1);
  }, [resetKey]);

  useEffect(() => {
    if (page > totalPages) setPage(totalPages);
  }, [page, totalPages]);

  const start = (safePage - 1) * pageSize;
  return {
    page: safePage,
    setPage,
    pageItems: list.slice(start, start + pageSize),
    total,
    totalPages,
    pageSize
  };
}
